import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { Row, Col, Card, Form } from "react-bootstrap";
import { collectioncreate, collectiondatewise, collectionupdate, datecollectionlist, grouplist } from "../../../services/admin";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";

export default function Addcollection() {
    const navigate = useNavigate();
    const { id, gid } = useParams();
    const [glist, setGlist] = useState([]);
    const [mglist, setMGlist] = useState([]);
    const [mgrpid, setMGrpId] = useState("");
    const [grpid, setGrpId] = useState("");
    const [staffid, setGStaff] = useState("");
    const [gcenter, setGCenter] = useState("");
    const [cdate, setCDate] = useState("");
    const [clist, setCList] = useState([]);

    const [isalready, setIsAlready] = useState(false);
    const location = useLocation();
    const [urllink, setUrllink] = useState("");


    useEffect(() => {

        const path = location.pathname.split("/")[2];
        setUrllink(path);
        if (path === "editcollection") {
            setCDate(id);
            // setIsAlready(true);
            datecollectionlist(id, gid).then((resp) => {
                if (resp.status === true) {
                    // setCList(resp.data);
                    if (resp.data.length > 0) {
                        const temp = new FormData();
                        temp.append("branch", localStorage.getItem("branch"));
                        grouplist(temp).then((res) => {
                            if (res.status === true) {
                                setMGlist(res.data);
                                let arr = [];
                                let arr1 = {};
                                if (res.data.length > 0) {
                                    for (let i = 0; i < res.data.length; i++) {
                                        if (resp.data[0].loan_group == res.data[i].id) {
                                            arr.push({
                                                value: res.data[i].id,
                                                label: res.data[i].group_name
                                            })
                                            arr1 = res.data[i];
                                        }
                                    }
                                    setGStaff(arr1.group_collection_staff);
                                    setGCenter(arr1.group_center);
                                    setGrpId(resp.data[0].loan_group);
                                    setMGrpId(arr[0]);
                                }
                            }
                        })


                        const temp2 = new FormData();
                        temp2.append("group_id", resp.data[0].loan_group);
                        temp2.append("collection_date", id);
                        collectiondatewise(temp2).then((res) => {
                            if (res.status === true) {
                                // setCList(res.data);
                                const adata = res.data.some((item) => item.loan_paiddate !== "");
                                let arr = [];
                                if (adata) {
                                    arr = res.data.map((item) => {
                                        return {
                                            ...item,
                                            loan_collection: (parseFloat(item.loan1_collection) || 0) + (parseFloat(item.loan2_collection) || 0),
                                        };
                                    });
                                }
                                setCList(arr);

                            }
                        });
                    }

                }
            });


        } else {
            setCDate(moment(new Date()).format("YYYY-MM-DD"));
            const temp = new FormData();
            temp.append("branch", localStorage.getItem("branch"));
            grouplist(temp).then((res) => {
                if (res.status === true) {
                    setMGlist(res.data);
                    let arr = [];
                    if (res.data.length > 0) {
                        for (let i = 0; i < res.data.length; i++) {
                            arr.push({
                                value: res.data[i].id,
                                label: res.data[i].group_name
                            })
                        }

                        setGlist(arr);
                    }
                }
            })
        }



    }, [location.pathname])

    function handlegroup(e) {
        if (e !== null) {
            setMGrpId(e)
            setGrpId(e.value);
            setGCenter("");
            funlist(e.value, cdate);
            if (mglist.length > 0) {
                mglist.map((item) => {
                    if (item.id == e.value) {
                        setGStaff(item.group_collection_staff);
                        setGCenter(item.group_center);
                    }
                })
            }
        } else {
            setMGrpId("")
            setGrpId("");
            setGCenter("");
            funlist("", cdate);
        }

    }

    function funlist(fid, fdate) {
        setCDate(fdate);
        setCList([]);
        // setIsAlready(false);
        if (fid != "" && fdate != "") {
            const temp = new FormData();
            temp.append("group_id", fid);
            temp.append("collection_date", fdate);
            collectiondatewise(temp).then((res) => {
                if (res.status === true) {
                    const formatted = (res.data || []).map((item) => {
                        let coll = item.loan_collection;
                        if (coll === "" || coll == null) {
                            if (item.loan1_collection && item.loan2_collection) {
                                coll = (parseInt(item.loan1_collection) + parseInt(item.loan2_collection)).toString();
                            } else if (item.loan1_collection) {
                                coll = item.loan1_collection.toString();
                            } else if (item.loan2_collection) {
                                coll = item.loan2_collection.toString();
                            } else {
                                coll = "";
                            }
                        }
                        return {
                            ...item,
                            loan_collection: coll,
                        };
                    });
                    setCList(formatted);
                    const adata = res.data.some((item) => item.loan_paiddate !== "");
                    if (adata) {
                        // setIsAlready(true);
                    }
                }
            });
        }
    }

    const handleInputChange = (index, field, value) => {
        setCList((prev) => {
            const updated = [...prev];
            updated[index] = { ...updated[index], [field]: value };
            return updated;
        });
    };
    const calculateTotal = (member) => {
        const loan1 = parseInt(member.loan1_total) || 0;
        const loan2 = parseInt(member.loan2_total) || 0;
        const loanOD1 = 0
        // parseInt(member.loan_previous_od1) || 0;
        const loanOD2 = 0
        // parseInt(member.loan_previous_od2) || 0;


        // if (member.loan_previous_od !== null) {
        //     return loan1 + loan2 + loanOD;
        // } else {
        //     return loan1 + loan2;
        // }

        let total = loan1 + loan2;

        // Add loan_od values if they are not null or zero
        if (loanOD1 !== 0) {
            total += loanOD1;
        }

        if (loanOD2 !== 0) {
            total += loanOD2;
        }
        return total;

    };

    const handleCollectionValidation = (index, value) => {
        const totalAmountLoan2 = clist[index].totalAmountLoan2 ? clist[index].totalAmountLoan2 : 0; // Loan amount specific to this row
        const totalAmountLoan1 = clist[index].totalAmountLoan1 ? clist[index].totalAmountLoan1 : 0; // Loan1 specific to this row
        const overall = totalAmountLoan1 + totalAmountLoan2;
        // If collection amount is greater than totalAmountLoan2 for the specific row
        if (parseInt(value) > overall) {
            toast.error(`Collection amount must be equal to the total amount. (${overall})`);
            value = "";  // Clear the value on input field
            handleInputChange(index, 'loan_collection', "");  // Reset the collection value for this index
        } else {
            handleInputChange(index, 'loan_collection', value);  // Proceed with valid input

            // If the collection value is zero, reset overdraft values for that row
            if (parseInt(value) === 0) {
                handleInputChange(index, 'loan1_od', totalAmountLoan1.toString());
                handleInputChange(index, 'loan2_od', totalAmountLoan2.toString());

                // Update the specific row in the clist
                const updatedCList = [...clist];
                updatedCList[index] = {
                    ...updatedCList[index],
                    loan1_od: totalAmountLoan1.toString(),
                    loan2_od: totalAmountLoan2.toString()
                };
                setCList(updatedCList);  // Apply the updated list
            }
        }
    };

    function handleSubmit(e) {
        e.preventDefault();
        let sdata = true;
        if (urllink !== "editcollection") {
            sdata = clist.length > 0 && clist.every((item) => {
                const val = item.loan_collection;
                if (val === null || val === undefined || val === "") {
                    return false;
                }
                const num = parseFloat(val);
                return !isNaN(num) && num >= 0;
            });
        }
        console.log(clist);

        console.log(sdata);
        // const ddata = clist.every((item) => 
        //     (item.loan_collection > 0) ? 
        //     (item.loan1_emi >= item.loan_collection || 
        //      item.loan2_emi >= item.loan_collection || 
        //      item.loan_od >= item.loan_collection) : 
        //     true
        // );
        let errorFound = false;
        clist.forEach((item, index) => {
            const loan1Total = parseFloat(item.loan1_total) || 0;
            const loan2Total = parseFloat(item.loan2_total) || 0;
            const loanPreviousOD1 = parseFloat(item.loan_previous_od1) || 0;
            const loanPreviousOD2 = parseFloat(item.loan_previous_od2) || 0;
            const loanCollection = parseFloat(item.loan_collection) || 0;

            // Check if the sum of loan amounts equals the loan_collection
            // if (loanCollection !== 0 && (loanPreviousOD1 + loan1Total + loanPreviousOD2 + loan2Total) !== loanCollection) {
            //     // Show error toast if the sum doesn't match
            //     errorFound = true;
            //     toast.error(`Collection amount must be equal to the total amount. (${loanPreviousOD1 + loan1Total + loanPreviousOD2 + loan2Total})`);
            // }
            const previousODSum = loanPreviousOD1 + loanPreviousOD2;
            const loanTotalSum = loan1Total + loan2Total;

            if (
                loanCollection !== 0 &&
                loanCollection !== previousODSum &&
                loanCollection !== loanTotalSum
            ) {
                errorFound = true;
                toast.error(
                    `Collection amount must be equal to either Previous OD total (${previousODSum}) or Loan total (${loanTotalSum}).`
                );
            }

        });
        if (!errorFound) {
            if (sdata) {
                setLoading(true);
                // if(ddata){
                const temp = new FormData();
                for (let i = 0; i < clist.length; i++) {
                    temp.append(`loan_members[${i}][loan_member]`, clist[i].member_id);
                    temp.append(`loan_members[${i}][loan_group]`, grpid);
                    temp.append(`loan_members[${i}][loan_staff]`, staffid);
                    temp.append(`loan_members[${i}][loan1_scheme]`, clist[i].loan1_scheme);
                    temp.append(`loan_members[${i}][loan1_amount]`, clist[i].loan1_amount);
                    temp.append(`loan_members[${i}][loan1_turn]`, clist[i].loan1_turn);
                    temp.append(`loan_members[${i}][loan1_ins]`, clist[i].loan1_ins);
                    temp.append(`loan_members[${i}][loan1_emi]`, clist[i].loan1_total);
                    temp.append(`loan_members[${i}][loan1_od]`, clist[i].loan1_total);
                    temp.append(`loan_members[${i}][loan2_scheme]`, clist[i].loan2_scheme);
                    temp.append(`loan_members[${i}][loan2_amount]`, clist[i].loan2_amount);
                    temp.append(`loan_members[${i}][loan2_turn]`, clist[i].loan2_turn);
                    temp.append(`loan_members[${i}][loan2_ins]`, clist[i].loan2_ins);
                    temp.append(`loan_members[${i}][loan2_emi]`, clist[i].loan2_total);
                    temp.append(`loan_members[${i}][loan2_od]`, clist[i].loan2_total);
                    // temp.append(`loan_members[${i}][loan_od]`, clist[i].loan_od);
                    if (clist[i].loan_collection !== null) {
                        temp.append(`loan_members[${i}][total_collection]`, clist[i].loan_collection);
                    } else {
                        temp.append(`loan_members[${i}][total_collection]`, "");
                    }
                    if (clist[i].loan_remarks !== null) {
                        temp.append(`loan_members[${i}][remarks]`, clist[i].loan_remarks);
                    } else {
                        temp.append(`loan_members[${i}][remarks]`, "");
                    }
                    temp.append(`loan_members[${i}][collection_date]`, cdate);
                }
                if (urllink === "editcollection") {
                    collectionupdate(temp).then((res) => {
                        if (res.status === true) {
                            setLoading(false);
                            toast.success(res.message);
                            navigate("/collection/allcollection");
                        } else {
                            setLoading(false);
                            toast.error(res.message);
                        }
                    });
                } else {
                    collectioncreate(temp).then((res) => {
                        if (res.status === true) {
                            setLoading(false);
                            toast.success(res.message);
                            navigate("/collection/allcollection");
                        } else {
                            setLoading(false);
                            toast.error(res.message);
                        }
                    });
                }

                // }else{
                //     toast.error("Collection amount must not be less than the loan EMIs or OD amount.");
                // }

            } else {
                toast.error("Please Enter Collection Amount");
            }
        }


    }

    // const handleBlur = (e, index, memb) => {
    //     let totalAmountLoan1 = 0;
    //     let totalAmountLoan2 = 0;
    //     let loan1 = parseFloat(memb.loan1_total) || 0;
    //     let loan2 = parseFloat(memb.loan2_total) || 0;
    //     let loanOD1 = parseFloat(memb.loan_previous_od1) || 0;
    //     let loanOD2 = parseFloat(memb.loan_previous_od2) || 0;


    //     if (memb.loan_previous_od1 != 0) {
    //         totalAmountLoan1 = loan1 + loanOD1;
    //     } else {
    //         totalAmountLoan1 = loan1;
    //     }
    //     if (memb.loan_previous_od2 != 0) {
    //         totalAmountLoan2 = loan2 + loanOD2;
    //     } else {
    //         totalAmountLoan2 = loan2;
    //     }
    //     const value = e.target.value;
    //     const tvalue = totalAmountLoan1 + totalAmountLoan2

    //     // Check if the lengths of 'value' and 'tvalue' match
    //     if (value.length === tvalue.length) {
    //         // If lengths match, proceed to check the numeric value
    //         handleInputChange(index, 'loan_collection', value);

    //         // Check if the numeric value is zero, and reset loan values if true
    //         if (parseInt(value) === 0) {
    //             handleInputChange(index, 'loan1_od', totalAmountLoan1.toString());
    //             handleInputChange(index, 'loan2_od', totalAmountLoan2.toString());

    //             // Update the list with the reset loan values
    //             const updatedCList = [...clist];
    //             updatedCList[index] = {
    //                 ...updatedCList[index],
    //                 loan1_od: totalAmountLoan1.toString(),
    //                 loan2_od: totalAmountLoan2.toString()
    //             };
    //             setCList(updatedCList);
    //         }
    //     } else {
    //         // If the lengths don't match, show an error and reset the input
    //         if (value !== tvalue) {
    //             toast.error("Collection amount must be equal to total amount. (" + tvalue + ")");
    //             e.target.value = ""; // Clear the input field
    //             handleInputChange(index, 'loan_collection', ""); // Reset the loan collection field
    //         }
    //     }
    // };

    const [inputValue, setInputValue] = useState('');
    const [loading, setLoading] = useState(false);

    return (
        <div>
            <div className="page-header">
                <div>
                    <h2 className="main-content-title tx-24 mg-b-5">{urllink === "editcollection" ? "Edit Recovery Posting" : "Recovery Posting"}</h2>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a>Collection</a>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                            {urllink === "editcollection" ? "Edit Recovery Posting" : "Recovery Posting"}
                        </li>
                    </ol>
                </div>
            </div>
            {loading && (
                <div className="loader-wrapper">
                    <div className="loader"></div>
                    <h3>Loading...Please do not go back or close the window.</h3>
                </div>
            )}
            {!loading &&
                <div className="content-body">
                    <div className="row">
                        {/* {urllink !== "editcollection" && */}
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-header">
                                    <h2 className="main-content-title tx-24 mg-b-5">
                                        Select Group
                                    </h2>
                                </div>
                                <div className="card-body">
                                    <div className="row">

                                        <div className="col-xl-4 col-sm-6">
                                            <div className="mb-6">
                                                <label className="form-label">
                                                    Group<span className="text-danger"> *</span>
                                                </label>
                                                <Select
                                                    className="default-select"
                                                    placeholder="Select Select Group"
                                                    value={mgrpid}
                                                    options={glist}
                                                    onChange={handlegroup}
                                                    isSearchable={true}
                                                    isClearable
                                                    hidden
                                                    isDisabled={urllink === "editcollection" ? true : false}
                                                />

                                                {/* <select className="default-select form-control wide" onChange={handlegroup} value={grpid}>
                                              <option value="" disabled>Select Group</option>
                                              {glist.map((item, index) => {
                                                  return (
                                                      <option key={index} value={item.id}>
                                                          {item.group_name}
                                                      </option>
                                                  );
                                              })}
                                          </select> */}
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-sm-6">
                                            <div className="mb-6">
                                                <label className="form-label">
                                                    Center
                                                </label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={gcenter}
                                                    onChange={(e) => setGCenter(e.target.value)}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-sm-6">
                                            <div className="mb-6">
                                                <label className="form-label">
                                                    Collection Date
                                                </label>
                                                <input
                                                    className="form-control"
                                                    type="date"
                                                    value={cdate}
                                                    min={localStorage.getItem("Role") == 3 ? cdate : ''}
                                                    max={localStorage.getItem("Role") == 3 ? cdate : ''}
                                                    onChange={(e) => funlist(grpid, e.target.value)}
                                                    disabled={urllink === "editcollection" ? true : false}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        {/* } */}


                        <div className="col-lg-12 mt-2">

                            <Card>
                                <div className="table-container">

                                    <table className="responsive-table">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Name</th>
                                                <th>Amount</th>
                                                <th>Turn</th>
                                                <th>Ins</th>
                                                <th>EMI</th>
                                                <th>Amount</th>
                                                <th>Turn</th>
                                                <th>Ins</th>
                                                <th>EMI</th>
                                                <th>OD</th>
                                                <th>Total</th>
                                                <th>Collection</th>
                                                <th>Remarks</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {clist.map((member, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td width={"20%"}>
                                                        <input
                                                            type="text"
                                                            value={member.member_name}
                                                            className="input-field total-field"
                                                            readOnly
                                                        />
                                                    </td>

                                                    {/* Loan 1 */}
                                                    <td width={"10%"}>
                                                        <input
                                                            type="text"
                                                            value={member.loan1_amount}
                                                            className="input-field total-field"
                                                            readOnly
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            value={member.loan1_turn}
                                                            className="input-field total-field"
                                                            readOnly
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            value={member.loan1_ins}
                                                            className="input-field total-field"
                                                            readOnly
                                                        />
                                                    </td>

                                                    <td width={"10%"}>
                                                        <input
                                                            type="text"
                                                            value={member.loan1_total}
                                                            className="input-field total-field"
                                                            readOnly
                                                        />
                                                    </td>


                                                    <td width={"10%"}>
                                                        <input
                                                            type="text"
                                                            value={member.loan2_amount != 0 ? member.loan2_amount : ""}
                                                            className="input-field total-field"
                                                            readOnly
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            value={member.loan2_turn}
                                                            className="input-field total-field"
                                                            readOnly
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            value={member.loan2_ins}
                                                            className="input-field total-field"
                                                            readOnly
                                                        />
                                                    </td>

                                                    <td width={"10%"}>
                                                        <input
                                                            type="text"
                                                            value={member.loan2_total}
                                                            // value={member.loan2_total != 0 ? member.loan2_total : ""}
                                                            className="input-field total-field"
                                                            readOnly
                                                        />
                                                    </td>
                                                    {urllink === "editcollection" &&
                                                        <td width={"10%"}>
                                                            <input
                                                                type="text"
                                                                value={parseInt(member.loan1_od) + parseInt(member.loan2_od)}
                                                                className="input-field total-field"
                                                                // readOnly
                                                                onChange={(e) => { handleInputChange(index, 'loan_od', e.target.value); handleInputChange(index, 'loan1_od', e.target.value); handleInputChange(index, 'loan2_od', e.target.value) }}

                                                            />
                                                        </td>
                                                    }
                                                    {urllink !== "editcollection" &&
                                                        <td width={"10%"}>
                                                            <input
                                                                type="text"
                                                                value={parseInt(member.loan1_od) + parseInt(member.loan2_od)}
                                                                className="input-field total-field"
                                                            // readOnly
                                                            // onChange={(e) => handleInputChange(index, 'loan_od', e.target.value)}

                                                            />
                                                        </td>
                                                    }
                                                    <td width={"10%"}>
                                                        <input
                                                            type="text"
                                                            // value={member.loan1_total + member.loan2_total}
                                                            value={calculateTotal(member)}
                                                            className="input-field total-field"
                                                            readOnly
                                                        />
                                                    </td>

                                                    {urllink === "editcollection" &&
                                                        <td width={"10%"}>
                                                            <input
                                                                type="text"
                                                                value={
                                                                    member.loan_collection}
                                                                className="input-field total-field"
                                                                onInput={(e) => {
                                                                    const value = e.target.value;
                                                                    if (/[^0-9]/.test(value)) {
                                                                        e.target.value = value.replace(/[^0-9]/g, '');
                                                                    }
                                                                }}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    if (value === "") {
                                                                        handleInputChange(index, 'loan_collection', ""); // Clear the collection if input is empty
                                                                    } else {
                                                                        let totalAmountLoan1 = 0;
                                                                        let totalAmountLoan2 = 0;
                                                                        let loan1 = parseFloat(member.loan1_total) || 0;
                                                                        let loan2 = parseFloat(member.loan2_total) || 0;
                                                                        let loanOD1 = parseFloat(member.loan_previous_od1) || 0;
                                                                        let loanOD2 = parseFloat(member.loan_previous_od2) || 0;

                                                                        if (member.loan_previous_od1 !== 0) {
                                                                            totalAmountLoan1 = loan1 + loanOD1;
                                                                        } else {
                                                                            totalAmountLoan1 = loan1;
                                                                        }
                                                                        if (member.loan_previous_od2 !== 0) {
                                                                            totalAmountLoan2 = loan2 + loanOD2;
                                                                        } else {
                                                                            totalAmountLoan2 = loan2;
                                                                        }

                                                                        const tvalue = totalAmountLoan1 + totalAmountLoan2;

                                                                        if (value !== "") {
                                                                            if (value > tvalue) {
                                                                                toast.error("Collection amount must be equal to total amount." + " (" + tvalue + ")");
                                                                                e.target.value = "";
                                                                                handleInputChange(index, 'loan_collection', "");
                                                                            } else {
                                                                                setInputValue(value);
                                                                                handleInputChange(index, 'loan_collection', value);
                                                                                // if (parseInt(value) === 0) {
                                                                                //     handleInputChange(index, 'loan1_od', totalAmountLoan1.toString());
                                                                                //     handleInputChange(index, 'loan2_od', totalAmountLoan2.toString());
                                                                                //     const updatedCList = [...clist];
                                                                                //     updatedCList[index] = { ...updatedCList[index], loan1_od: totalAmountLoan1.toString() };
                                                                                //     updatedCList[index] = { ...updatedCList[index], loan2_od: totalAmountLoan2.toString() };
                                                                                //     setCList(updatedCList);
                                                                                // }
                                                                            }
                                                                        } else {
                                                                            setInputValue("");
                                                                            handleInputChange(index, 'loan_collection', ""); // Clear if empty
                                                                            // handleInputChange(index, 'loan1_od', member.loan_previous_od1.toString());
                                                                            // handleInputChange(index, 'loan2_od', member.loan_previous_od2.toString());
                                                                            // const updatedCList = [...clist];
                                                                            // updatedCList[index] = { ...updatedCList[index], loan1_od: member.loan_previous_od1.toString() };
                                                                            // updatedCList[index] = { ...updatedCList[index], loan2_od: member.loan_previous_od2.toString() };
                                                                            // setCList(updatedCList);
                                                                        }
                                                                    }
                                                                }}
                                                            />
                                                        </td>

                                                    }

                                                    {urllink !== "editcollection" &&
                                                        <td width={"10%"}>
                                                            <input
                                                                type="text"
                                                                value={member.loan_collection !== null && member.loan_collection !== undefined ? member.loan_collection : ""}
                                                                className="input-field total-field"
                                                                // readOnly={isalready}
                                                                onInput={(e) => {
                                                                    const value = e.target.value;
                                                                    // Allow only numeric input
                                                                    if (/[^0-9]/.test(value)) {
                                                                        e.target.value = value.replace(/[^0-9]/g, '');
                                                                    }
                                                                }}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    let totalAmountLoan1 = 0;
                                                                    let totalAmountLoan2 = 0;
                                                                    let loan1 = parseFloat(member.loan1_total) || 0;
                                                                    let loan2 = parseFloat(member.loan2_total) || 0;
                                                                    let loanOD1 = parseFloat(member.loan_previous_od1) || 0;
                                                                    let loanOD2 = parseFloat(member.loan_previous_od2) || 0;

                                                                    if (member.loan_previous_od1 !== 0) {
                                                                        totalAmountLoan1 = loan1 + loanOD1;
                                                                    } else {
                                                                        totalAmountLoan1 = loan1;
                                                                    }
                                                                    if (member.loan_previous_od2 !== 0) {
                                                                        totalAmountLoan2 = loan2 + loanOD2;
                                                                    } else {
                                                                        totalAmountLoan2 = loan2;
                                                                    }

                                                                    const tvalue = totalAmountLoan1 + totalAmountLoan2;

                                                                    if (value !== "") {
                                                                        const numVal = parseFloat(value) || 0;
                                                                        if (numVal > tvalue) {
                                                                            toast.error("Collection amount must be equal to total amount. (" + tvalue + ")");
                                                                            e.target.value = "";
                                                                            setCList((prev) => {
                                                                                const updated = [...prev];
                                                                                updated[index] = { ...updated[index], loan_collection: "" };
                                                                                return updated;
                                                                            });
                                                                        } else {
                                                                            setInputValue(value);
                                                                            setCList((prev) => {
                                                                                const updated = [...prev];
                                                                                const updatedItem = {
                                                                                    ...updated[index],
                                                                                    loan_collection: value,
                                                                                };
                                                                                if (parseInt(value) === 0) {
                                                                                    updatedItem.loan1_od = totalAmountLoan1.toString();
                                                                                    updatedItem.loan2_od = totalAmountLoan2.toString();
                                                                                }
                                                                                updated[index] = updatedItem;
                                                                                return updated;
                                                                            });
                                                                        }
                                                                    } else {
                                                                        setInputValue("");
                                                                        setCList((prev) => {
                                                                            const updated = [...prev];
                                                                            updated[index] = {
                                                                                ...updated[index],
                                                                                loan_collection: "",
                                                                                loan1_od: member.loan_previous_od1 ? member.loan_previous_od1.toString() : "0",
                                                                                loan2_od: member.loan_previous_od2 ? member.loan_previous_od2.toString() : "0",
                                                                            };
                                                                            return updated;
                                                                        });
                                                                    }
                                                                }}
                                                            />
                                                        </td>

                                                    }

                                                    <td width={"10%"}>
                                                        <input
                                                            type="text"
                                                            readOnly={isalready}
                                                            value={member.loan_remarks}
                                                            className="input-field total-field"
                                                            onChange={(e) => handleInputChange(index, 'loan_remarks', e.target.value)}
                                                        />
                                                    </td>

                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan={2}>Total</td>
                                                <td>
                                                    {clist.reduce((total, member) => total + parseFloat(member.loan1_amount || 0), 0)}
                                                </td>
                                                <td>

                                                </td>
                                                <td>
                                                </td>
                                                <td>
                                                    {clist.reduce((total, member) => total + parseFloat(member.loan1_total || 0), 0)}
                                                </td>
                                                <td>
                                                    {clist.reduce((total, member) => total + parseFloat(member.loan2_amount || 0), 0)}
                                                </td>
                                                <td>
                                                </td>
                                                <td>
                                                </td>
                                                <td>
                                                    {clist.reduce((total, member) => total + parseFloat(member.loan2_total || 0), 0)}
                                                </td>
                                                {/* {urllink === "editcollection" &&
                                            <td>
                                                {clist.reduce((total, member) => total + parseFloat(member.loan_od || 0) , 0)}
                                            </td>
} */}

                                                {/* {urllink !== "editcollection" && */}
                                                <td>
                                                    {clist.reduce((total, member) => total + parseFloat(member.loan1_od || 0) + parseFloat(member.loan2_od || 0), 0)}
                                                </td>
                                                {/* } */}
                                                <td>
                                                    {clist.reduce((total, member) => {
                                                        let loan1Total = parseFloat(member.loan1_total || 0);
                                                        let loan2Total = parseFloat(member.loan2_total || 0);
                                                        let loanOd1 = 0;
                                                        // parseFloat(member.loan_previous_od1 || 0);
                                                        let loanOd2 = 0;
                                                        // parseFloat(member.loan_previous_od2 || 0);

                                                        if (member.loan_previous_od1 != 0 || member.loan_previous_od2 != 0) {
                                                            total += loan1Total + loan2Total + loanOd1 + loanOd2; // Add loan_od to the total if previous_loan_od exists
                                                        } else {
                                                            total += loan1Total + loan2Total;
                                                        }
                                                        return total;
                                                        // If loan_od is not null or 0, add loan_od; otherwise, add loan1_total + loan2_total
                                                        // return total + (loanOd !== 0 ? loanOd : loan1Total + loan2Total);
                                                    }, 0)}
                                                    {/* {clist.reduce((total, member) => total + (parseFloat(member.loan1_total || 0) + parseFloat(member.loan2_total || 0) ), 0)} */}
                                                    {/* + parseFloat(member.loan_od || 0) */}
                                                </td>
                                                <td>
                                                    {clist.reduce((total, member) => total + parseFloat(member.loan_collection || 0), 0)}
                                                </td>
                                                <td></td>
                                            </tr>
                                        </tfoot>
                                    </table>

                                    <div className="res-right mt-2">
                                        {urllink === "editcollection" &&
                                            <a onClick={() => navigate("/collection/allcollection")} className="btn btn-secondary me-2"> Back</a>
                                        }
                                        {!isalready &&
                                            <button className="btn btn-success" onClick={handleSubmit} disabled={loading}>{loading ? "Submitting..." : "Submit"}</button>

                                        }
                                    </div>
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>
            }

        </div>
    );
}